(function () {
  var D = document, root = D.documentElement;
  var CFG = window.IWK || {};
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }

  /* ---------- age gate ---------- */
  D.addEventListener('click', function (e) {
    if (e.target.closest('[data-iwk-age-yes]')) {
      try { localStorage.setItem('iwk_age_ok', '1'); } catch (x) {}
      D.cookie = 'iwk_age_ok=1; path=/; max-age=31536000; SameSite=Lax';
      root.classList.add('iwk-age-ok');
    }
    if (e.target.closest('[data-iwk-age-no]')) {
      var p = D.querySelector('[data-iwk-age-declined]'); if (p) p.hidden = false;
    }
  });

  /* ---------- Christmas line cutoff (second check, in the browser) ---------- */
  function xmasCheck() {
    D.querySelectorAll('[data-iwk-xmas-cutoff]').forEach(function (el) {
      var cut = Date.parse(el.getAttribute('data-iwk-xmas-cutoff'));
      if (isNaN(cut) || Date.now() >= cut) el.remove();
    });
  }
  xmasCheck();
  D.addEventListener('DOMContentLoaded', xmasCheck);
  setInterval(xmasCheck, 60000);

  /* ---------- cart drawer ---------- */
  var drawer = D.getElementById('iwk-cart');
  function setCount(n) {
    D.querySelectorAll('[data-iwk-count]').forEach(function (el) { el.textContent = n > 0 ? '(' + n + ')' : ''; });
  }
  function render(cart) {
    if (!drawer) return;
    setCount(cart.item_count);
    var lines = drawer.querySelector('[data-iwk-lines]');
    var summary = drawer.querySelector('[data-iwk-summary]');
    var footer = drawer.querySelector('[data-iwk-footer]');
    if (!cart.items.length) {
      lines.innerHTML = '<p style="margin:0; font-size:15px; line-height:1.6; color:#CFD3E6">Your cart is empty.</p>';
      summary.style.display = 'none'; footer.style.display = 'none'; return;
    }
    summary.style.display = ''; footer.style.display = '';
    lines.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? '<img src="' + esc(it.image) + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="' + esc(it.product_title) + '" width="84" style="width:84px; height:auto; display:block">' : '';
      return '<div style="display:flex; gap:14px">' + img +
        '<div style="flex:1; display:flex; flex-direction:column; gap:8px">' +
        '<span style="font-family:Anton, Impact, sans-serif; font-size:17px; letter-spacing:.03em; line-height:1.15">' + esc(it.product_title).toUpperCase() + '</span>' +
        '<span style="font-size:13px; color:#8A90BC">127 cards · 21+</span>' +
        (CFG.preorder && CFG.shipBy && CFG.shipBy[it.variant_id] ? '<span style="font-size:13px; font-weight:bold; color:#FFDE5C">Preorder · ' + esc(CFG.shipBy[it.variant_id]) + '</span>' : '') +
        '<div style="display:flex; align-items:center; gap:12px">' +
        '<div style="display:flex; align-items:center; border:2px solid #2A2F52">' +
        '<button type="button" data-iwk-line="' + (i + 1) + '" data-iwk-delta="-1" aria-label="Decrease quantity" style="background:none; border:none; color:#FFF9F0; padding:6px 12px; font-size:16px; cursor:pointer; font-family:Anton, Impact, sans-serif">−</button>' +
        '<span style="min-width:24px; text-align:center; font-family:Anton, Impact, sans-serif; font-size:16px">' + it.quantity + '</span>' +
        '<button type="button" data-iwk-line="' + (i + 1) + '" data-iwk-delta="1" aria-label="Increase quantity" style="background:none; border:none; color:#FFF9F0; padding:6px 12px; font-size:16px; cursor:pointer; font-family:Anton, Impact, sans-serif">+</button>' +
        '</div>' +
        '<span style="font-family:Anton, Impact, sans-serif; font-size:18px; color:#FFDE5C">' + money(it.final_line_price) + '</span>' +
        '</div></div></div>';
    }).join('');
    drawer.querySelector('[data-iwk-subtotal]').textContent = money(cart.total_price);
    drawer.querySelector('[data-iwk-total]').textContent = '· ' + money(cart.total_price);
  }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function open() {
    if (!drawer) { location.href = '/cart'; return; }
    getCart().then(function (c) { render(c); drawer.hidden = false; root.style.overflow = 'hidden'; });
  }
  function close() { if (drawer) { drawer.hidden = true; root.style.overflow = ''; } }

  var busy = false;
  D.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-iwk-open-cart]'))) { e.preventDefault(); open(); return; }
    if ((t = e.target.closest('[data-iwk-close-cart]'))) { close(); return; }
    if ((t = e.target.closest('[data-iwk-qty]'))) {
      var v = D.querySelector('[data-iwk-qty-value]');
      if (v) { v.textContent = Math.max(1, Math.min(9, (parseInt(v.textContent, 10) || 1) + parseInt(t.getAttribute('data-iwk-qty'), 10))); }
      return;
    }
    if ((t = e.target.closest('[data-iwk-add]'))) {
      if (busy || t.disabled) return;
      var id = t.getAttribute('data-iwk-variant') || CFG.variantId;
      if (!id) { location.href = '/collections/all'; return; }
      var qv = D.querySelector('[data-iwk-qty-value]');
      var qty = t.hasAttribute('data-iwk-variant') && qv ? (parseInt(qv.textContent, 10) || 1) : 1;
      busy = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(open)
        .catch(function (err) { alert((err && (err.description || err.message)) || 'Could not add to cart. Please try again.'); })
        .then(function () { busy = false; });
      return;
    }
    if ((t = e.target.closest('[data-iwk-line]'))) {
      if (busy) return; busy = true;
      var line = Number(t.getAttribute('data-iwk-line')), delta = Number(t.getAttribute('data-iwk-delta'));
      getCart().then(function (c) {
        var cur = c.items[line - 1] ? c.items[line - 1].quantity : 0;
        var q = Math.max(0, Math.min(9, cur + delta));
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: q }) });
      }).then(function (r) { return r.json(); }).then(render)
        .catch(function () {}).then(function () { busy = false; });
    }
  });
  D.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();
